type NewsletterSignupDebug = Record<string, unknown>;

function extractDebug(value: unknown): NewsletterSignupDebug | undefined {
	if (value && typeof value === 'object' && 'debug' in value) {
		const debug = (value as { debug?: unknown }).debug;
		if (debug && typeof debug === 'object') {
			return debug as NewsletterSignupDebug;
		}
	}
	return undefined;
}

/**
 * Logs the Klaviyo debug payload to the browser console on a successful
 * newsletter signup. The server only attaches `debug` on BETA, so on prod this
 * is a no-op.
 */
export function logNewsletterSignupResponse(response: unknown): void {
	const debug = extractDebug(response);
	if (debug) {
		console.log('[newsletter-signup] Klaviyo response:', debug);
	}
}

/**
 * Logs the Klaviyo debug payload to the browser console on a failed newsletter
 * signup. The payload carries the underlying error message and the raw Klaviyo
 * response. The server attaches `debug` on BETA only, and `FetchUtilsError`
 * exposes the parsed server body on its `response` property.
 */
export function logNewsletterSignupError(err: unknown): void {
	const body =
		err && typeof err === 'object' && 'response' in err ? (err as { response?: unknown }).response : undefined;
	const debug = extractDebug(body);
	if (debug) {
		console.error('[newsletter-signup] Klaviyo error:', debug);
	}
}
